import _ from '@triotech/vue-core/src/plugins/_';
import NotFound from '@/views/NotFound';
import Login from '@/views/Authentication/login';
import Logout from '@/views/Authentication/logout';
import Dashboard from '@/views/Dashboard';
import Evaluation from '@/views/Evaluation';
import Certification from '@/views/Certification';
import Preparation from '@/views/Preparation';
import CompletedTest from '@/views/CompletedTest';
import Account from '@/views/Account';
import PasswordRequest from '@/views/PasswordRequest';
import PasswordReset from '@/views/PasswordReset';
import SmartLogin from '@/views/SmartLogin'
import Elearning from '@/views/Elearning'

export default [{
  path: '/',
  name: 'dashboard',
  component: Dashboard,
}, {
  path: '/login/:displayModal?',
  name: 'login',
  component: Login,
  props: _.queryPropsValidator.bind(_, Login),
}, {
  path: '/request',
  name: 'request',
  component: PasswordRequest,
}, {
  path: '/resetting/:token/:firstLogin?',
  name: 'resetting',
  component: PasswordReset,
  props: _.queryPropsValidator.bind(_, PasswordReset),
}, {
  path: '/evaluation/:setHistory?',
  name: 'evaluation',
  component: Evaluation,
  props: _.queryPropsValidator.bind(_, Evaluation),
}, {
  path: '/certification/:setHistory?',
  name: 'certification',
  component: Certification,
  props: _.queryPropsValidator.bind(_, Certification),
}, {
  path: '/preparation/:setHistory?',
  name: 'preparation',
  component: Preparation,
  props: _.queryPropsValidator.bind(_, Preparation),
}, {
  path: '/completed_test',
  name: 'completed_test',
  component: CompletedTest,
}, {
  path: '/account',
  name: 'account',
  component: Account,
}, {
  path: '/logout',
  name: 'logout',
  component: Logout,
}, {
  path: '/404/',
  name: 'not_found',
  component: NotFound,
},{
  path: '/smart_login/:token',
  name: 'smart_login',
  component: SmartLogin,
},{
  path: '/elearning',
  name: 'elearning',
  component: Elearning,
},];
